"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/** Error that is thrown if a LinkPresenter calls the cancel callback. */
var CancelError = /** @class */ (function (_super) {
    __extends(CancelError, _super);
    function CancelError(reason) {
        var _this = _super.call(this, "User canceled request " + (reason ? '(' + reason + ')' : '')) || this;
        _this.code = 'E_CANCEL';
        return _this;
    }
    return CancelError;
}(Error));
exports.CancelError = CancelError;
/** Error that is thrown if an identity request fails to verify. */
var IdentityError = /** @class */ (function (_super) {
    __extends(IdentityError, _super);
    function IdentityError(reason) {
        var _this = _super.call(this, "Unable to verify identity " + (reason ? '(' + reason + ')' : '')) || this;
        _this.code = 'E_IDENTITY';
        return _this;
    }
    return IdentityError;
}(Error));
exports.IdentityError = IdentityError;
/** Error that is thrown by session transport. */
var SessionError = /** @class */ (function (_super) {
    __extends(SessionError, _super);
    function SessionError(reason, code) {
        var _this = _super.call(this, reason) || this;
        _this.code = code;
        return _this;
    }
    return SessionError;
}(Error));
exports.SessionError = SessionError;
//# sourceMappingURL=errors.js.map